import(/* webpackMode: "eager" */ "/github/workspace/src/app/error.tsx");
